import { api } from "aldoo-ra/API"

const storeAPI = api("store")
const orders = (op, params = {}) => storeAPI({ orders: { op, ...params } })

/**
 * The whole store's orders (aldoo-na `store {orders}`, admin): the api
 * StoreOrders reads unless a project passes its own (aldoo.com: a seller's).
 */
export const storeOrdersAPI = {
  list: (options) => orders("list", options),
  get: (order_id) => orders("get", { order_id }),
  // the order's buyer's orders (the Client tab): { search?, page?, items_per_page? } → { data, total }
  clientOrders: (order_id, options = {}) => orders("client_orders", { order_id, ...options }),
  // on its way, with the parcel's tracking number { number, carrier, url? }
  ship: (order_id, tracking) => orders("ship", { order_id, tracking }),
  // the number given or put right after shipping
  setTracking: (order_id, tracking) => orders("tracking", { order_id, tracking }),
  // the seller's return address, kept the project's way (asked for when accepting a return without one)
  setReturnAddress: (order_id, address) => orders("return_address", { order_id, address }),
  // canceling mails the buyer, with `message` (the seller's words) when given
  setStatus: (order_id, orderStatus, { message } = {}) => orders("status", { order_id, orderStatus, ...(message ? { message } : {}) }),
  refund: (order_id, { lines, amount, shipping, reason } = {}) => orders("refund", { order_id, lines, amount, shipping, reason }),
  // goods came back (aldoo-na/store/returns): what, why, and whether they go back on sale
  markReturned: (order_id, { lines, reason, note, restock, request_id, request_ids } = {}) => orders("return", { order_id, lines, reason, note, restock, request_id, request_ids }),
  // answer a buyer's return request: "accepted" | "declined", with a message to them
  resolveRequest: (order_id, { request_id, decision, message } = {}) => orders("resolve_request", { order_id, request_id, decision, message }),
  // answer a buyer's request to cancel an order not yet sent: "accepted" refunds and cancels it
  resolveCancel: (order_id, { request_id, decision, message } = {}) => orders("resolve_cancel", { order_id, request_id, decision, message }),
  // change the items of an order not sent yet (aldoo-na/store/order-modify): `lines` the order as it should be
  modify: (order_id, { lines, message } = {}) => orders("modify", { order_id, lines, message }),
  // the products that can be put into it (the project's search), priced in the order's currency
  modifyProducts: (order_id, search) => orders("modify_products", { order_id, search }),
  // moving the order to another seller (aldoo-na/store/order-move): the project's sellers, products, quote
  moveSellers: (order_id, search) => orders("move_sellers", { order_id, search }),
  moveProducts: (order_id, sellerId, search) => orders("move_products", { order_id, sellerId, search }),
  moveMatch: (order_id, sellerId) => orders("move_match", { order_id, sellerId }),
  moveQuote: (order_id, { sellerId, lines, delivery } = {}) => orders("move_quote", { order_id, sellerId, lines, delivery }),
  move: (order_id, { sellerId, lines, delivery, message, reason } = {}) => orders("move", { order_id, sellerId, lines, delivery, message, reason }),
}
